import { lastValueFrom } from 'rxjs';

import { ExproModel, ExproOrderModel } from '@/models';
import { API_URL, getApiUrl } from '@/utils/api';
import ApiBase from './ApiBase';

export default class ExproService extends ApiBase {
  static baseUrl = getApiUrl(API_URL.USER, '/expro');
  static exproOrderBaseUrl = getApiUrl(API_URL.USER, '/exproOrder');

  getUnpaidExproListForUser(storeId): Promise<ExproModel[]> {
    return lastValueFrom(this.api.getJSON(`${ExproService.baseUrl}/${storeId}/getUnpaidExproListForUser`));
  }

  getUnpaidExproListForUserSap(storeId): Promise<ExproModel[]> {
    return lastValueFrom(this.api.getJSON(`${ExproService.baseUrl}/${storeId}/getUnpaidExproListForUserSap`));
  }

  getPayModes(storeId, isApplePayEnabled): Promise<any[]> {
    return lastValueFrom(this.api.getJSON(`${ExproService.exproOrderBaseUrl}/${storeId}/getPayments?isApplePayEnabled=${isApplePayEnabled}`));
  }

  createExproOrder(storeId, ordersId): Promise<ExproOrderModel> {
    return lastValueFrom(this.api.postJSON(`${ExproService.exproOrderBaseUrl}/${storeId}`, ordersId));
  }

  payExproOrder(processExproOrder, storeId): Promise<any> {
    return lastValueFrom(this.api.putJSON(`${ExproService.exproOrderBaseUrl}/${storeId}/processExproOrder`, processExproOrder));
  }

  validatePaymentExproOrder(storeId, processExproOrderRequest): Promise<any> {
    return lastValueFrom(this.api.putJSON(`${ExproService.exproOrderBaseUrl}/${storeId}/validatePaymentExproOrder`, processExproOrderRequest));
  }

  getExproOrder(storeId): Promise<ExproOrderModel> {
    return lastValueFrom(this.api.getJSON(`${ExproService.exproOrderBaseUrl}/${storeId}`));
  }

  getLastExproOrder(storeId): Promise<ExproOrderModel> {
    return lastValueFrom(this.api.getJSON(`${ExproService.exproOrderBaseUrl}/${storeId}/last`));
  }

  updateExproOrder(exproOrder): Promise<ExproOrderModel | string> {
    return lastValueFrom(this.api.putJSON(`${ExproService.exproOrderBaseUrl}/update`, exproOrder));
  }

  deleteExpros(exproIds: string[]): Promise<any> {
    return this.api.postPromisedJSON(`${ExproService.baseUrl}/toDelete`, { orderIds: exproIds });
  }
}
